import { render, staticRenderFns } from "./PostContentEditor.vue?vue&type=template&id=266f545e&scoped=true&"
import script from "./PostContentEditor.vue?vue&type=script&lang=js&"
export * from "./PostContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./PostContentEditor.vue?vue&type=style&index=0&id=266f545e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f545e",
  null
  
)

export default component.exports